import type { ReactNode } from 'react';
import { LockIcon } from '@src/components/icons/LockIcon';
import './BrowserPreview.css';

/** Decorative browser chrome around a live game preview; the address is illustrative. */
export function BrowserPreview({ address, children }: { address: string; children: ReactNode }) {
  return <div className="browser-preview" data-testid="browser-preview">
    <div className="browser-preview__toolbar">
      <span className="browser-preview__dots" aria-hidden="true"><i /><i /><i /></span>
      <span className="browser-preview__address"><LockIcon /><span>{address}</span></span>
    </div>
    <div className="browser-preview__content">{children}</div>
  </div>;
}
